import { render, staticRenderFns } from "./SelectPickType.vue?vue&type=template&id=97d28510&"
import script from "./SelectPickType.vue?vue&type=script&lang=js&"
export * from "./SelectPickType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports